import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import PlanCompatibilityMessage from 'marketplace-ui-common/compatibility/components/PlanCompatibilityMessage';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import useRequiredPlansForIntegrationFeatures from '../../hooks/useRequiredPlansForIntegrationFeatures';
import { getMissingCompatibilityRequirements } from '../../../installability/utils/featureCompatibilities';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlanCompatibility = ({
  appContext,
  features,
  integrationFeatures,
  installability,
  isOpsHubListing,
  onOpenFeatureCompatibilityModal,
  tiers,
  trackInteraction
}) => {
  const {
    hubInstallable
  } = installability || {};
  const {
    requiredPlans: integrationFeaturesRequiredPlans,
    compatibilityLoading,
    compatibilityError
  } = useRequiredPlansForIntegrationFeatures({
    appContext: appContext === 'admin-preview' ? 'public' : appContext,
    integrationFeatures: integrationFeatures || []
  });
  const featuresMissingCompatibilityRequirements = getMissingCompatibilityRequirements(features, installability);
  const missingRequirements = useMemo(() => {
    if (features !== null && features !== void 0 && features.length) {
      return featuresMissingCompatibilityRequirements.filter(requirement => !!requirement);
    } else {
      return integrationFeaturesRequiredPlans.filter(plan => !!plan);
    }
  }, [features, featuresMissingCompatibilityRequirements, integrationFeaturesRequiredPlans]);
  const featureCompatibilityStatus = getDataFetchingClientRequestState(compatibilityError, compatibilityLoading);
  const compatibilityType = useMemo(() => {
    if (!hubInstallable) {
      return 'COMPATIBLE_NONE';
    } else if (missingRequirements.length) {
      return 'COMPATIBLE_SOME';
    } else {
      return 'COMPATIBLE_ALL';
    }
  }, [hubInstallable, missingRequirements]);
  const opsHubLoadingStatus = isOpsHubListing ? featureCompatibilityStatus : RequestState.SUCCEEDED;
  const pageLoadingStatus = appContext === 'app' && !installability ? RequestState.PENDING : opsHubLoadingStatus;
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: pageLoadingStatus,
    children: /*#__PURE__*/_jsx(PlanCompatibilityMessage, {
      appContext: appContext === 'admin-preview' ? 'public' : appContext,
      compatibilityType: compatibilityType,
      helpText: compatibilityType === 'COMPATIBLE_SOME' ? /*#__PURE__*/_jsx(UIHelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.compatibilityDisclaimer"
        })
      }) : undefined,
      onTrackInteraction: trackInteraction,
      onFeaturesLinkClick: () => onOpenFeatureCompatibilityModal(),
      showCompatiblePlansLink: !isOpsHubListing,
      tiers: tiers
    })
  });
};